import React from 'react';
import { Phone } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

const ImprintPage = ({ language }) => {
  const translations = {
    de: {
      title: 'Impressum',
      contact: 'Kontakt',
      phone: 'Telefon',
      mobile: 'Mobil',
      email: 'E-Mail',
      taxId: 'Steuernummer',
      taxIdText: '248/248/20658',
      UStIdNr: 'Umsatzsteuer-Identifikationsnummer (USt-IdNr.) / Wirtschaftsidentifikationsnummer',
      UStIdNrText: 'DE461333286',
      businessReg: 'Gewerbeanmeldung',
      businessRegText: 'Die Gewerbeerlaubnis nach § 34c GewO wurde am 21.03.2026 durch das Ordnungsamt Burglengenfeld erteilt.',
      insurance: 'Angaben zur Berufshaftpflichtversicherung',
      insurerName: 'Name und Sitz des Versicherers:',
      insurerScope: 'Geltungsraum der Versicherung:',
      germany: 'Deutschland',
      editorial: 'Redaktionell verantwortlich',
      dispute: 'Verbraucherstreitbeilegung/Universalschlichtungsstelle',
      disputeText: 'Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.',
      dsa: 'Zentrale Kontaktstelle nach dem Digital Services Act - DSA (Verordnung (EU) 2022/265)',
      dsaIntro: 'Unsere zentrale Kontaktstelle für Nutzer und Behörden nach Art. 11, 12 DSA erreichen Sie wie folgt:',
      dsaLang: 'Die für den Kontakt zur Verfügung stehenden Sprachen sind: Deutsch, Englisch.',
      source: 'Quelle'
    },
    en: {
      title: 'Imprint',
      contact: 'Contact',
      phone: 'Phone',
      mobile: 'Mobile',
      email: 'Email',
      taxId: 'Tax ID number',
      taxIdText: '248/248/20658',
      UStIdNr: 'Value-Added Tax (VAT) Identification Number / Business Identification Number',
      UStIdNrText: 'DE461333286',
      businessReg: 'Business Registration',
      businessRegText: 'The business license according to § 34c GewO was issued on March 21, 2026 by the following authority: Ordnungsamt Burglengenfeld.',
      insurance: 'Professional Liability Insurance Information',
      insurerName: 'Name and address of insurer:',
      insurerScope: 'Geographical scope of insurance:',
      germany: 'Germany',
      editorial: 'Editorially responsible',
      dispute: 'Consumer Dispute Resolution',
      disputeText: 'We are not willing or obliged to participate in dispute resolution proceedings before a consumer arbitration board.',
      dsa: 'Central Contact Point under the Digital Services Act - DSA (Regulation (EU) 2022/265)',
      dsaIntro: 'Our central contact point for users and authorities according to Art. 11, 12 DSA can be reached as follows:',
      dsaLang: 'The languages available for contact are: German, English.',
      source: 'Source'
    }
  };

  const t = translations[language] || translations.de;

  return (
    <div className="min-h-screen py-16 bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold mb-4" style={{ color: '#E53D4A' }}>
            {t.title}
          </h1>
        </div>

        <div className="space-y-6">
          {/* Main Contact */}
          <Card>
            <CardContent className="pt-6">
              <div className="space-y-1 text-gray-700 dark:text-gray-300">
                <p className="font-semibold">Felix Martinez</p>
                <p>Martinez IT Systems</p>
                <p>Georg-Weist-Straße 40</p>
                <p>93133 Burglengenfeld</p>
              </div>
            </CardContent>
          </Card>

          {/* Kontakt */}
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center space-x-2" style={{ color: '#E53D4A' }}>
                <Phone className="h-5 w-5" />
                <span>{t.contact}</span>
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="space-y-2 text-gray-700 dark:text-gray-300">
                <p><span className="font-medium">{t.phone}:</span> 09471/9978600</p>
                <p><span className="font-medium">{t.mobile}:</span> 015569/104058</p>
                <p><span className="font-medium">{t.email}:</span> <a href="mailto:kontakt@martinez.systems" className="text-[#E53D4A] hover:underline">kontakt@martinez.systems</a></p>
              </div>
            </CardContent>
          </Card>

          {/* Steuernummer */}
          <Card>
            <CardHeader>
              <CardTitle style={{ color: '#E53D4A' }}>
                {t.taxId}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-700 dark:text-gray-300">
                {t.taxIdText}
              </p>
            </CardContent>
          </Card>

          {/* Umsatzsteuer-ID-Nummer */}
          <Card>
            <CardHeader>
              <CardTitle style={{ color: '#E53D4A' }}>
                {t.UStIdNr}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-700 dark:text-gray-300">
                {t.UStIdNrText}
              </p>
            </CardContent>
          </Card>

          {/* Wirtschaftsidentifikationsnummer 
          <Card>
            <CardHeader>
              <CardTitle style={{ color: '#E53D4A' }}>
                {t.WIdNr}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-700 dark:text-gray-300">
                {t.WIdNrText}
              </p>
            </CardContent>
          </Card>
          */}

          {/* Gewerbeanmeldung */}
          <Card>
            <CardHeader>
              <CardTitle style={{ color: '#E53D4A' }}>
                {t.businessReg}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-700 dark:text-gray-300">
                {t.businessRegText}
              </p>
            </CardContent>
          </Card>

          {/* Berufshaftpflichtversicherung 
          <Card>
            <CardHeader>
              <CardTitle style={{ color: '#E53D4A' }}>
                {t.insurance}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="space-y-4 text-gray-700 dark:text-gray-300">
                <div>
                  <p className="font-semibold mb-2">{t.insurerName}</p>
                  <p>Beispiel Versicherung AG</p>
                  <p>Musterweg 10</p>
                  <p>90210 Musterstadt</p>
                </div>
                <div>
                  <p className="font-semibold mb-1">{t.insurerScope}</p>
                  <p>{t.germany}</p>
                </div>
              </div>
            </CardContent>
          </Card>*/}

          {/* Redaktionell verantwortlich */}
          <Card>
            <CardHeader>
              <CardTitle style={{ color: '#E53D4A' }}>
                {t.editorial}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="text-gray-700 dark:text-gray-300">
                <p>Felix Martinez</p>
                <p>Georg-Weist-Straße 40</p>
                <p>93133 Burglengenfeld</p>
              </div>
            </CardContent>
          </Card>

          {/* Verbraucherstreitbeilegung */}
          <Card>
            <CardHeader>
              <CardTitle style={{ color: '#E53D4A' }}>
                {t.dispute}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-700 dark:text-gray-300">
                {t.disputeText}
              </p>
            </CardContent>
          </Card>

          {/* DSA Kontaktstelle */}
          <Card>
            <CardHeader>
              <CardTitle style={{ color: '#E53D4A' }}>
                {t.dsa}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="space-y-3 text-gray-700 dark:text-gray-300">
                <p>{t.dsaIntro}</p>
                <div>
                  <p><span className="font-medium">{t.email}:</span> <a href="mailto:kontakt@martinez.systems" className="text-[#E53D4A] hover:underline">kontakt@martinez.systems</a></p>
                  <p><span className="font-medium">{t.phone}:</span> 09471/9978600</p>
                </div>
                <p>{t.dsaLang}</p>
              </div>
            </CardContent>
          </Card>

          {/* Quelle */}
          <div className="text-center pt-8">
            <p className="text-sm text-gray-600 dark:text-gray-400">
              {t.source}: <a href="https://www.e-recht24.de/" target="_blank" rel="noopener noreferrer" className="text-[#E53D4A] hover:underline">https://www.e-recht24.de/</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImprintPage;
